import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Button, Segment} from 'semantic-ui-react';

import {CircularProgress, Backdrop} from '@ui';

import useAuthenticateCoordinator from '../hooks/useAuthenticateCoordinator';

export function Authenticate(props) {
    const {
        loaderMessage,
        showTakeoverButton,
        remainingTtlMs,
        start,
        takeover,
        reset,
    } = useAuthenticateCoordinator({
        dispatch: props.dispatch,
    });

    React.useEffect(() => {
        if (props.shouldRedirect) {
            start();
        } else {
            reset({showCompleted: true});
        }
    }, [props.shouldRedirect, reset, start]);

    const autoRetrySeconds = showTakeoverButton && null !== remainingTtlMs
        ? Math.ceil(remainingTtlMs / 1000)
        : null;

    return (
        <Segment className='applicationLoader'>
            <Backdrop open >
                <div className='content'>
                    <CircularProgress size='large' />
                    <div style={{marginTop: '1rem', fontSize: '24px'}}>{loaderMessage}</div>
                    {showTakeoverButton && (
                        <div style={{marginTop: '1rem', marginBottom: '1rem', fontSize: '0.7em', opacity: 0.85}}>
                            Complete sign-in in the tab that opened the sign-in page with <strong>`Log in | AV-CMP`</strong> in the title.
                        </div>
                    )}
                    {showTakeoverButton && (
                        <div style={{marginTop: '2rem', marginBottom: '1rem'}}>
                            <Button onClick={takeover} primary>
                                Sign in from this tab
                            </Button>
                        </div>
                    )}
                    {null !== autoRetrySeconds && (
                        <div style={{marginTop: '0.5rem', marginBottom: '0.5rem', fontSize: '0.5em', opacity: 0.85}}>
                            Auto-retry in {autoRetrySeconds}s if sign-in stalls.
                        </div>
                    )}
                </div>
            </Backdrop>
        </Segment>
    );
}

Authenticate.propTypes = {
    dispatch: PropTypes.func,
    shouldRedirect: PropTypes.bool,
};
Authenticate.defaultProps = {
    dispatch: null,
    shouldRedirect: false,
};

const mapStateToProps = (state) => {
    return {
        shouldRedirect: state.app.security.shouldRedirect,
    };
};

export default connect(mapStateToProps)(Authenticate);
